import { useLogSentryInfo } from "./useLogSentryInfo";
import { sentryPages } from "~/utils/sentry/sentry-pages";

export const useSendClientErrorToSentry = () => {
  const logSentryInfo = useLogSentryInfo();
  const route = useRoute();

  return async (error: any) => {
    if (sentryPages.some((page) => route.path?.includes(page))) {
      const VueSentry = await import("@sentry/vue");
      logSentryInfo();
      VueSentry.captureException(error);
    }
  };
};
